"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementFocus = void 0;
const react_1 = require("react");
const components_1 = require("@veeam/components");
const useElementFocus = ({ onDone, onClose, }) => {
    const mainRef = react_1.useRef(null);
    const handleKeyDown = react_1.useCallback((event) => {
        event.stopPropagation();
        if (event.keyCode === components_1.KeyCode.Escape) {
            onClose();
            return;
        }
        if (event.keyCode === components_1.KeyCode.Enter) {
            onDone();
        }
    }, []);
    react_1.useEffect(() => {
        const timerId = window.setTimeout(() => {
            var _a;
            (_a = mainRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
        return () => {
            window.clearTimeout(timerId);
        };
    }, []);
    return {
        innerRef: mainRef,
        tabIndex: -1,
        onKeyDown: handleKeyDown,
    };
};
exports.useElementFocus = useElementFocus;
//# sourceMappingURL=useElementFocus.js.map